import React from 'react';
import {getColumns} from '../helpers/form';
import {NPC_DAMAGETYPES} from './npcConstants';

class DamageTypeList extends React.Component {

    renderColumn = (types) => {
        return types.map(type => <div className="form-group col-4" key={`skill-${type.key}`}>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" name="skills" value={type.key} id={`skill${type.key}Check`} checked={this.props.hasType(type.key)} onChange={this.props.changeType} />
                <label className="form-check-label" htmlFor={`skill${type.key}Check`}>
                    {type.name}
                </label>
            </div>
        </div>);
    };

    render() {
        const columns = getColumns(NPC_DAMAGETYPES, 2);

        return <div className="row">
            {columns.map((column, index) => {
                return <div className="col-6" key={`damagetype-col-${index}`}>
                    {this.renderColumn(column)}
                </div>;
            })}
        </div>;
    }
}

export default DamageTypeList;